import { FC, PropsWithChildren, useContext } from 'react';
import { createPortal } from 'react-dom';

import { BottomSheetContext } from '@hh.ru/magritte-ui-bottom-sheet/BottomSheetContext';

export const BottomSheetContentOverlay: FC<PropsWithChildren> = ({ children }) => {
    const { contentOverlayRef } = useContext(BottomSheetContext);
    return contentOverlayRef.current !== null ? createPortal(children, contentOverlayRef.current) : null;
};
